import myStyles from "../../../styles/housing/HousingAllocations.module.css"

export function RoomSelection({ room, clickAction, selectedRoom }) {
  return (
    <div
      className={`${myStyles.houseBlock} ${
        room.id === selectedRoom?.id ? myStyles.houseBlockSelected : ""
      }`}
      onClick={() => {
        clickAction(room)
      }}
      style={{ cursor: "pointer" }}
    >
      <div className="house-text-wrapper" style={{ color: "black" }}>
        {room.name}
        <span style={{ fontSize: 13 }}>{room.shortAddress}</span>
      </div>
    </div>
  )
}
